export default __webpack_public_path__ + "content/media/9.46aadec7.jpg";